/**
 * The SCI lockup: shield left, wordmark on three lines.
 *
 * The shield's vertical split is fixed: left half Pride Amber, right half
 * Respect Orange. Do not reverse it, rotate it or change the notch.
 */
export function SciLogo() {
  return (
    <div className="sci-logo">
      <svg
        className="sci-logo__shield"
        viewBox="0 0 37 44"
        fill="none"
        role="img"
        aria-label="Strata Community Insurance"
      >
        <path d="M0 0 H18.5 V44 L0 36 Z" fill="#F7901E" />
        <path d="M18.5 0 H37 V36 L18.5 44 Z" fill="#F26722" />
      </svg>
      <span className="sci-logo__wordmark" aria-hidden="true">
        Strata
        <br />
        Community
        <br />
        Insurance
      </span>
    </div>
  )
}
